import { useContext } from 'react';
import { FootnoteContext } from '~/components/footnotes/footnote-context';

export const useFootnotes = () => {
	return useContext(FootnoteContext);
};
